<script setup lang="ts">
import { computed } from 'vue';
import Chart from 'primevue/chart';
import { useAccountStore } from '@apparatix/stores/useAccountStore';

const store = useAccountStore();

const setChartOptions = () => {
  const documentStyle = getComputedStyle(document.documentElement);
  const textColor = documentStyle.getPropertyValue('--text-color');
  const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
  const surfaceBorder = documentStyle.getPropertyValue('--surface-950');

  return {
    maintainAspectRatio: false,
    aspectRatio: 0.6,
    plugins: { legend: { labels: { color: textColor }}},
    scales: {
      x: {
        ticks: { color: textColorSecondary },
        grid: { color: surfaceBorder },
      },
      y: {
        ticks: { color: textColorSecondary },
        grid: { color: surfaceBorder },
      },
    },
  };
};


const setChartData = computed(() => {
  const documentStyle = getComputedStyle(document.documentElement);

  return {
    labels: store.revenueGraph.map(revenue => revenue.month),
    datasets: [
      {
        label: 'Advertiser Future 12 Months',
        data: store.revenueGraph.map(revenue => revenue.advertiserFuture),
        fill: false,
        borderColor: documentStyle.getPropertyValue('--blue-500'),
        tension: 0.4,
      },
      {
        label: 'Industry Future Average',
        data: store.revenueGraph.map(revenue => revenue.futureMonthAverage),
        fill: false,
        borderColor: documentStyle.getPropertyValue('--red-500'),
        tension: 0.4,
      },
      {
        label: 'Advertiser Previous 12 Months',
        data: store.revenueGraph.map(revenue => revenue.advertiserPrevious),
        fill: false,
        borderColor: documentStyle.getPropertyValue('--orange-500'),
        tension: 0.4,
        hidden: true,
      },
    ],
  };
});

</script>
<template>
  <div class="w-full">
    <div class="w-full h-auto" style="position: relative;">
      <Chart
        type="line"
        :data="setChartData"
        :options="setChartOptions"
      />
    </div>
  </div>
</template>
